// RoomTypeList.jsx
import React, { useEffect, useState } from "react";

import AddRoomType from "./Components/AddRoomType";
import EditRoomType from "./Components/EditRoomType";
import RoomTypeTable from "./Components/RoomTypeTable";
import BackButton from "../../../Universal/Hotels/Components/BackButton";
import api from "../../../../api/axios";
import Swal from "sweetalert2";

const RoomTypeList = () => {
  const [roomTypes, setRoomTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedRoomType, setSelectedRoomType] = useState(null);

  const fetchRoomTypes = async () => {
    try {
      const res = await api.get("/pms/room-types");
      setRoomTypes(res.data || []);
    } catch (err) {
      console.error("Failed to fetch room types:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoomTypes();
  }, []);

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the room type.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`/pms/room-types/${id}`);

          Swal.fire({
            icon: "success",
            title: "Room Type Deleted!",
            text: "The room type has been removed.",
            timer: 1500,
            showConfirmButton: false,
          });

          fetchRoomTypes();
        } catch (error) {
          console.error("Delete failed:", error);
          Swal.fire({
            icon: "error",
            title: "Failed to delete",
            text: error.response?.data?.message || "Something went wrong.",
          });
        }
      }
    });
  };

  const openEdit = (type) => {
    setSelectedRoomType(type);
    setIsEditOpen(true);
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <BackButton />

          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Room Type List</h3>

            <button className="btn btn-dark" onClick={() => setIsAddOpen(true)}>
              Add Room Type
            </button>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <RoomTypeTable
              data={roomTypes}
              loading={loading}
              onEdit={openEdit}
              onDelete={handleDelete}
            />
          </div>
        </div>

        <AddRoomType
          open={isAddOpen}
          onClose={() => setIsAddOpen(false)}
          onAdded={fetchRoomTypes}
        />

        <EditRoomType
          open={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          roomType={selectedRoomType}
          onUpdated={fetchRoomTypes}
        />
      </div>
    </div>
  );
};

export default RoomTypeList;
